import { DocumentRequestModuleType } from '@enums/document-request-module-type.enum';

export const DOCUMENT_REQUEST_MODULE_TYPE_LABEL: Record<DocumentRequestModuleType, string> = {
  [DocumentRequestModuleType.TNS]: 'TNS',
  [DocumentRequestModuleType.RESULT_ALLOCATION]: 'Affectation résultat',
  [DocumentRequestModuleType.LEASING]: 'Crédits-bails',
  [DocumentRequestModuleType.STOCK]: 'Stocks',
  [DocumentRequestModuleType.CUSTOM]: 'Demande libre'
};
